import { forwardRef } from 'react';
import { IconButton, styled } from '@mui/material';
import { useThemeProps } from '@mui/material/styles';
import { Facebook } from '@mui/icons-material';

export interface ShareOnFacebookButtonProps {
    url?: string;
}

const ShareOnFacebookButtonRoot = styled(IconButton, {
    name: 'MuiShareOnFacebookButton',
    slot: 'root',
})({});

export const ShareOnFacebookButton = forwardRef<HTMLButtonElement, ShareOnFacebookButtonProps>(
    function ShareOnFacebookButton(inProps, ref) {
        const props = useThemeProps({ props: inProps, name: 'MuiShareOnFacebookButton' });
        const { url } = props;
        const myUrlWithParams = new URL('https://www.facebook.com/sharer/sharer.php');
        if (url) {
            myUrlWithParams.searchParams.append('u', url);
        }

        return (
            <ShareOnFacebookButtonRoot
                ref={ref}
                aria-label="Facebook Icon"
                color="primary"
                size="small">
                <a href={myUrlWithParams.href} target="_blank" rel="noopener noreferrer">
                    <Facebook />
                </a>
            </ShareOnFacebookButtonRoot>
        );
    }
);

export default ShareOnFacebookButton;
